import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";
import { GetWorkflowDocument, type WorkflowRow } from "#app/lib/data";

/**
 * One workflow, by id. `GetWorkflow` spreads `WorkflowListItem_workflow`, so
 * `workflow` IS the row type the workflows table renders — the same object
 * goes to the settings screen and to `DeleteWorkflowDialog` with no reshaping.
 */
export function useWorkflowDetail(workflowId: string | undefined) {
  const variables = useMemo(() => ({ id: workflowId! }), [workflowId]);

  const { data, loading, error } = useQuery(GetWorkflowDocument, {
    variables,
    fetchPolicy: "cache-and-network",
    skip: !workflowId,
  });

  const workflow: WorkflowRow | null = data?.workflow ?? null;
  const stageCount = data?.workflow?.stages?.total ?? 0;

  return { workflow, stageCount, loading, error };
}
